import type { TestMultipleChoiceSchemaType } from '@vedalib/editor/lib/brand'
import React, { useCallback, useId } from 'react'

import type { ElementStyleCss } from 'services/Branding/types'
import { testPropsEl } from 'utils/test/qaData'

import CheckboxStyled from '../../styled/CheckboxStyled'
import LabelStyled from '../../styled/LabelStyled'
import MarkStyled from '../../styled/MarkStyled'

// import * as s from './Checkbox.module.scss'

interface ICheckboxProps {
  disabled?: boolean
  checked: boolean
  onChange?: (value: boolean) => void
  setIsValid?: (value: boolean) => void
  styles: ElementStyleCss<TestMultipleChoiceSchemaType>
  value: string
  testData: string
  isEditor?: boolean
  children: React.ReactNode
}

const Checkbox: React.FC<ICheckboxProps> = ({
  disabled,
  checked,
  onChange,
  setIsValid,
  children,
  styles,
  value,
  testData,
  isEditor,
}) => {
  const id = useId()
  const handleOnChange = useCallback(() => onChange?.(!checked), [checked, onChange])
  const handleSetIsValid = useCallback(() => setIsValid?.(!checked), [checked, setIsValid])

  return (
    <CheckboxStyled
      {...testPropsEl('courseCheckbox', { value }, { checked, testData })}
      // className={cn(s.root, { [s.disabled]: disabled, [s.checked]: checked })}
      $disabled={disabled}
      $styles={styles}
      htmlFor={id}
    >
      <input
        checked={checked}
        disabled={disabled}
        id={isEditor ? undefined : id}
        onChange={handleOnChange}
        role='checkbox'
        type='checkbox'
      />
      <MarkStyled
        {...testPropsEl('checkmarkCheckbox', { value }, { checked, testData })}
        $checked={checked}
        $disabled={disabled}
        $styles={styles}
        aria-label={isEditor ? `Mark as ${checked ? 'incorrect' : 'correct'} answer` : undefined}
        onClick={isEditor ? handleSetIsValid : undefined}
        onKeyDown={
          isEditor
            ? (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  handleSetIsValid()
                }
              }
            : undefined
        }
        role={isEditor ? 'button' : undefined}
        tabIndex={isEditor ? 0 : undefined}
      />
      <LabelStyled /* className={s.label} */ $styles={styles}>{children}</LabelStyled>
    </CheckboxStyled>
  )
}

export default React.memo(Checkbox)
